import React from "react";
import { connect } from "react-redux";

// @material-ui/core components
import { withStyles } from "tss-react/mui";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar } from "@fortawesome/free-solid-svg-icons/faStar";

// material-ui icons
import { Filter9Plus } from "@mui/icons-material";
import VestigingenFilter, { getVestigingFilterState } from "../../components/VestigingFilter/VestigingFilter";

// core components
import GridContainer from "../../components/Grid/GridContainer.jsx";
import GridItem from "../../components/Grid/GridItem.jsx";
import JamezzTable from "../../components/JamezzTable/JamezzTable";

import reviewsStyle from "../../assets/jss/material-dashboard-pro-react/views/reviewsStyle";
import MainNavbar from "../../components/Navbars/MainNavbar";
import * as actions from "../../store/actions";

//Modals
import TranslationWrapper, { getTranslation } from "../../components/TranslationWrapper/TranslationWrapper";
import { format } from "date-fns";

class Index extends React.Component {
  state = {
    selectedIds: [],
    showDeleteAlert: false,
  };

  customRating = (item) => {
    let starList = [];
    let starCount = 0;
    for (let cc = 0; cc < item.rating; cc++) {
      starList.push(
        <span key={"startList" + cc}>
          <FontAwesomeIcon icon={faStar} style={{ fontSize: "1.5em" }} />
        </span>
      );
      starCount++;
    }
    for (let cc = starCount; cc < 5; cc++) {
      starList.push(
        <span key={"startList" + cc}>
          <FontAwesomeIcon icon={faStar} style={{ fontSize: "1.5em", color: "#cfcfcf" }} />
        </span>
      );
    }
    return starList;
  };

  customDate = (item) => {
    return format(new Date(item.created_at), "dd-MM-yyyy HH:mm:ss");
  };

  render() {
    return (
      <div>
        <MainNavbar paginaTitel={<TranslationWrapper tDefault={"Reviews overview"} tKey={"reviews.pagetitle"} />} />

        <GridContainer>
          <VestigingenFilter />
        </GridContainer>
        <GridContainer>
          <GridItem xs={12}>
            <JamezzTable
              dataMapping={[
                { dbfield: "id", editable: false },
                { dbfield: "vestiging.systeemNaam", editable: false },
                { dbfield: "type", editable: false },
                // { dbfield: "rating", editable: false },
                {
                  customData: this.customRating,
                },
                // { dbfield: "created_at", editable: false },
                {
                  customData: this.customDate,
                },
                { dbfield: "notes", editable: false },
              ]}
              dbfields={"id,type,rating,notes,vestiging_id,created_at,vestiging.id,vestiging.systeemNaam"}
              fetchUrl={"core/reviews"}
              filters={this.props.filters}
              headerIcon={<Filter9Plus />}
              headers={[
                {
                  label: getTranslation("reviews.review.id", "#"),
                  sortable: true,
                  sortKey: "id",
                },
                {
                  label: getTranslation("reviews.review.vestiging", "Salesarea"),
                  sortable: false,
                  width: "10%",
                },
                {
                  label: getTranslation("reviews.review.type", "Type"),
                  sortable: false,
                  width: "10%",
                },
                {
                  label: getTranslation("reviews.review.naam", "Rating"),
                  width: "10%",
                  sortable: false,
                },
                {
                  label: getTranslation("reviews.review.date", "Datum"),
                  width: "10%",
                  sortable: false,
                },
                {
                  label: getTranslation("reviews.review.descr", "Notes"),
                  width: "60%",
                  sortable: false,
                },
              ]}
              reduxKey={"zones"}
              tableTitle={<TranslationWrapper tDefault={"Reviews"} tKey={"reviews.review.titel"} />}
            />
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

//REDUX
const mapStateToProps = (state) => {
  return {
    user_id: state.user.id,
    filters: getVestigingFilterState(state, true),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    showMessage: (message) => dispatch({ type: actions.SHOW_MESSAGE, message: message }),
    closeMessage: () => dispatch({ type: actions.CLOSE_MESSAGE }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(Index, reviewsStyle));
